// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/Popup/styles.scss
// module id = 820
// module chunks = 0